import { TrendingUp, TrendingDown } from "lucide-react"
import { cn } from "@/lib/utils"
import type { Metric } from "@/lib/types"

export function StatCard({ metric }: { metric: Metric }) {
  const isPositive = metric.change > 0
  const isNeutral = metric.label === "Avg Response Time"
  const displayPositive = isNeutral ? !isPositive : isPositive

  return (
    <div className="glass-strong rounded-xl p-5 shadow-sm">
      <p className="text-sm font-medium text-muted-foreground">{metric.label}</p>
      <div className="mt-2 flex items-end justify-between">
        <p className="text-3xl font-bold text-foreground">{metric.value}</p>
        <div
          className={cn(
            "flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
            displayPositive
              ? "bg-emerald-50 text-emerald-700"
              : "bg-red-50 text-red-600"
          )}
        >
          {isPositive ? (
            <TrendingUp className="h-3 w-3" />
          ) : (
            <TrendingDown className="h-3 w-3" />
          )}
          {Math.abs(metric.change)}%
        </div>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">{metric.changeLabel}</p>
    </div>
  )
}
